import { Route, Routes } from 'react-router';

import PrivateRoute from 'app/components/Util/PrivateRoute';
import Roles from 'utils/enums/Roles';
import { useAuthContext } from 'utils/hooks/useAuthContext';

import { ActivityDetail } from './ActivityDetail';
import { ActivityList } from './ActivityList';

export const ActivityLog = () => {
  const { user: currentUser } = useAuthContext();

  return (
    <Routes>
      <Route index element={<ActivityList />} />
      <Route
        path=":id"
        element={
          <PrivateRoute user={currentUser} requires={{ entitlements: [Roles.SUPER_USER] }}>
            <ActivityDetail />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
